export default "__VITE_ASSET__0svCU8nU__"